// tab.js - updated implementation
function initTabs() {
  // Find all tab instances on the page
  document
    .querySelectorAll(".product-tab-section, .wp-tabs")
    .forEach((tabInstance) => {
      const instanceId = tabInstance.dataset.tabInstance || "default";

      // Select elements within this instance only
      const firstTabPane = tabInstance.querySelector(
        ".tab-content .tab-pane:first-child"
      );
      const firstNavItem = tabInstance.querySelector(
        ".wp-tabs-nav .nav-item:first-child, .nav-tabs .nav-item:first-child"
      );

      if (firstTabPane) {
        firstTabPane.style.display = "block";
        firstTabPane.style.opacity = 1;
      }

      if (firstNavItem) {
        firstNavItem.classList.add("current");
      }

      // Add click event listeners specific to this instance
      tabInstance
        .querySelectorAll(".wp-tabs-nav .nav-item, .nav-tabs .nav-item")
        .forEach((tabControl) => {
          tabControl.addEventListener("click", function (e) {
            e.preventDefault();
            const $this = e.currentTarget;
            let targetSelector = $this.getAttribute("data-target");

            // Handle both formats: #tab-handle and #tab-handle-instanceId
            if (instanceId !== "default" && targetSelector) {
              const targetHandle = targetSelector.replace("#tab-", "");
              targetSelector = `#tab-${targetHandle}-${instanceId}`;
            }

            const $target = targetSelector
              ? document.querySelector(targetSelector)
              : null;

            // Remove 'current' class from all nav-items in this instance
            $this
              .closest(".wp-tabs-nav, .nav-tabs")
              .querySelectorAll(".nav-item")
              .forEach((sibling) => {
                sibling.classList.remove("current");
              });

            // Hide all tab-panes in this instance
            $this
              .closest(".nav-tab-info, .wp-tabs")
              .querySelectorAll(".tab-pane")
              .forEach((panel) => {
                panel.style.display = "none";
                panel.style.opacity = 0;
              });

            // Show and fade in the selected tab-pane
            $this.classList.add("current");
            if ($target) {
              $target.style.display = "block";
              $target.style.opacity = 0;
              $target.style.transition = "opacity 0.2s";
              setTimeout(() => {
                $target.style.opacity = 1;
              }, 10);
            }

            // Update view all button if it exists
            const viewAllButton = document.querySelector(
              ".all-product-view-btn"
            );
            const collectionUrl = $this.getAttribute("data-collection-url");
            if (collectionUrl && viewAllButton) {
              viewAllButton.setAttribute("href", collectionUrl);
            }
          });
        });
    });
}

function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}

const debouncedInitTabs = debounce(initTabs, 300);

// Event listeners for Shopify section events
document.addEventListener("shopify:section:load", debouncedInitTabs);
document.addEventListener("shopify:section:select", debouncedInitTabs);
document.addEventListener("shopify:section:deselect", debouncedInitTabs);
document.addEventListener("shopify:section:reorder", debouncedInitTabs);

// Initialize tabs on page load
document.addEventListener("DOMContentLoaded", initTabs);
